import {
  getDepartmentRankingList,
  getStaffDataWarehouseAuth,
  getFinancialYearTime,
  getBlocNetMarginInfo,
  getDepartmentNetMarginInfo,
  deliveryWxLogin,
  getDepartmentNetMarginInfoStore,
  getDepartmentIncomeInfo,
  getDepartmentGrossMarginInfo,
  getDepartmentFeeInfo,
  getStoreIncomeDetailsList,
  getDepartmentSubjectDetail,
  getLeastDepartmentDataInfo,
  getImpactFactorInfo,
  getGrossMarginRateFactorDetails,
  getDepartmentPartnerList,
  getProductGrossMarginInfo,
  getManageStaffDetail,
  getDepartmentConstituteAnalysis,
  getProductConstituteAnalysis,
  getLoseOrderInfo,
  getConstituteLoseOrderList,
  getLoseOrderTypeList,
  getProductLoseAreaAnalyse,
  getConstituteGrossMarginOrderList,
  getCheckMarginRate,
  getBlocHelpfulBoardInfo,
  getInfluenceFactor,
  getDepartmentManageAnomaly,
  getDepartmentAnalyse,
  getChannelAnalyse,
  getDepartmentNetMarginMarketInfo,
  getDepartmentMarketAnalyse,
  getEnergizeAnalyse,
  getDepartmentIncomeMarketInfo,
  getDepartmentFeeMarketInfo,
  getDepartmentSubjectMarketDetail,
  getChannelMarketAnalyse,
  getDepartmentManEfficiencyAnalyse,
  getDepartmentManAnalyse,
  getDepartmentTotalServerInfo,
  getDepartmentServerList,
  getTopButtonList,
  getNetMarginTendencyChart,
  getIncomeTendencyChart,
  getFilterTabDepartmentList,
  getBusinessDepartmentRanking,
  getStoreDepartmentRanking,
  getGroupDepartmentRanking,
  getCutTabDepartmentList,
  getDutyStaffList,
  saveComment,
  delComment,
  rejectWorkOrder,
  getWxStaffList
} from '@/api/bulletinBoard'
import { getToken, setToken, getSystemCode, setSystemCode, setDepartment, getDepartment } from '@/utils/auth'
import { Notify } from 'vant'

const state = {
  token: getToken(),
  systemCode: getSystemCode(),
  department: getDepartment(),
  selectIndex: 3,
  dateTypeCache: null,
  createWorkOrderButtonVisible: false
}

const mutations = {
  SET_TOEKN(state, token) {
    state.token = token
  },
  SET_SYSTEM_CODE(state, code) {
    state.systemCode = code
    setSystemCode(code)
  },
  SET_DEPARTMENT(state, department) {
    state.department = department
    setDepartment(department)
  },
  SET_SELECT_INDEX(state, index) {
    state.selectIndex = index
  },
  SET_DATE_TYPE_CACHE(state, dateTypeCache) {
    state.dateTypeCache = dateTypeCache
  },
  SET_CREATE_WORK_ORDER_BUTTON_VISIBLE(state, v) {
    state.createWorkOrderButtonVisible = v
  }
}

const actions = {

  cacheDepartment({ state, commit }, data) {
    commit('SET_DEPARTMENT', data)
  },
  cacheKanBanCode({ state, commit }, data) {
    commit('SET_SYSTEM_CODE', data)
  },

  getDepartmentRankingListNet({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDepartmentRankingList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('bulletinBoard/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      commit('SET_TOEKN', token)
      setToken(token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      commit('SET_TOEKN', '')
      throw error
    }
  },

  deliveryWxLogin({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      deliveryWxLogin(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 看板视野权限
  getStaffDataWarehouseAuth(temp, data) {
    return new Promise((resolve, reject) => {
      getStaffDataWarehouseAuth(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取财年时间段
  getFinancialYearTime(temp, data) {
    return new Promise((resolve, reject) => {
      getFinancialYearTime(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 集团净利数据
  getBlocNetMarginInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getBlocNetMarginInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 经营单元净利数据
  getDepartmentNetMarginInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentNetMarginInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 利润看板
  getDepartmentNetMarginInfoStore(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentNetMarginInfoStore(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 营收看板
  getDepartmentIncomeInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentIncomeInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 毛利率看板
  getDepartmentGrossMarginInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentGrossMarginInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getManageStaffDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getManageStaffDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 费用率看板
  getDepartmentFeeInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentFeeInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getStoreIncomeDetailsListNet(temp, data) {
    return new Promise((resolve, reject) => {
      getStoreIncomeDetailsList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentSubjectDetailNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentSubjectDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getLeastDepartmentDataInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getLeastDepartmentDataInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 经营影响因素
  getImpactFactorInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getImpactFactorInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 毛利率影响因素-详情
  getGrossMarginRateFactorDetails(temp, data) {
    return new Promise((resolve, reject) => {
      getGrossMarginRateFactorDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentPartnerList(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentPartnerList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 毛利分析-产品
  getProductGrossMarginInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getProductGrossMarginInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 毛利分析-部门
  getDepartmentConstituteAnalysis(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentConstituteAnalysis(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 毛利分析-产品项
  getProductConstituteAnalysis(temp, data) {
    return new Promise((resolve, reject) => {
      getProductConstituteAnalysis(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 输单分析
  getLoseOrderInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getLoseOrderInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 输单订单
  getConstituteLoseOrderList(temp, data) {
    return new Promise((resolve, reject) => {
      getConstituteLoseOrderList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 输单类型
  getLoseOrderTypeList(temp, data) {
    return new Promise((resolve, reject) => {
      getLoseOrderTypeList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 产品图表
  getProductLoseAreaAnalyse(temp, data) {
    return new Promise((resolve, reject) => {
      getProductLoseAreaAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 异常毛利订单
  getConstituteGrossMarginOrderList(temp, data) {
    return new Promise((resolve, reject) => {
      getConstituteGrossMarginOrderList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 异常订单-产品组成分析
  getCheckMarginRate(temp, data) {
    return new Promise((resolve, reject) => {
      getCheckMarginRate(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 赋能看板
  getBlocHelpfulBoardInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getBlocHelpfulBoardInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getInfluenceFactor(temp, data) {
    return new Promise((resolve, reject) => {
      getInfluenceFactor(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 业务-部门分析
  getDepartmentAnalyse(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentManageAnomaly(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentManageAnomaly(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 业务-渠道分析
  getChannelAnalyse(temp, data) {
    return new Promise((resolve, reject) => {
      getChannelAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDepartmentNetMarginMarketInfoNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentNetMarginMarketInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDepartmentMarketAnalyseNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentMarketAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getEnergizeAnalyseNet(temp, data) {
    return new Promise((resolve, reject) => {
      getEnergizeAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentIncomeMarketInfoNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentIncomeMarketInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentFeeMarketInfoNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentFeeMarketInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentSubjectMarketDetailNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentSubjectMarketDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getChannelMarketAnalyseNet(temp, data) {
    return new Promise((resolve, reject) => {
      getChannelMarketAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentManEfficiencyAnalyseNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentManEfficiencyAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentManAnalyseNet(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentManAnalyse(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentTotalServerInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentTotalServerInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDepartmentServerList(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentServerList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getTopButtonListNet(temp, data) {
    return new Promise((resolve, reject) => {
      getTopButtonList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  changeCreateWorkOrderButtonVisible({ commit }, v) {
    commit('SET_CREATE_WORK_ORDER_BUTTON_VISIBLE', v)
  },

  getNetMarginTendencyChart(temp, data) {
    return new Promise((resolve, reject) => {
      getNetMarginTendencyChart(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getIncomeTendencyChart(temp, data) {
    return new Promise((resolve, reject) => {
      getIncomeTendencyChart(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 01-筛选标签列表
  getFilterTabDepartmentList(temp, data) {
    return new Promise((resolve, reject) => {
      getFilterTabDepartmentList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 02-事业部排名
  getBusinessDepartmentRanking(temp, data) {
    return new Promise((resolve, reject) => {
      getBusinessDepartmentRanking(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 03-门店排名
  getStoreDepartmentRanking(temp, data) {
    return new Promise((resolve, reject) => {
      getStoreDepartmentRanking(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 04-小组排名
  getGroupDepartmentRanking(temp, data) {
    return new Promise((resolve, reject) => {
      getGroupDepartmentRanking(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 05-切换标签列表
  getCutTabDepartmentList(temp, data) {
    return new Promise((resolve, reject) => {
      getCutTabDepartmentList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取责任人
  getDutyStaffList(temp, data) {
    return new Promise((resolve, reject) => {
      getDutyStaffList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 添加评论
  saveComment(temp, data) {
    return new Promise((resolve, reject) => {
      saveComment(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除评论
  delComment(temp, data) {
    return new Promise((resolve, reject) => {
      delComment(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  rejectWorkOrder(temp, data) {
    return new Promise((resolve, reject) => {
      rejectWorkOrder(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getWxStaffList(temp, data) {
    return new Promise((resolve, reject) => {
      getWxStaffList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
